//
// # Param value stringification
//

import { Err, Ok, type Result } from "./result";

// Stringify a param value (`unknown`) to its string form for form inputs and
// model fields. Only primitives stringify meaningfully. `undefined` / `null`
// are expected (an absent value) and yield `Ok("")`. Objects / arrays are
// unexpected here, so we return an `Err` rather than silently emitting
// "[object Object]" or a fake empty string that would mask the type mismatch;
// callers decide whether to surface, log, or fall back.
export function paramValueToString(value: unknown): Result<string> {
  if (typeof value === "string") return Ok(value);
  if (typeof value === "number" || typeof value === "boolean") {
    return Ok(String(value));
  }
  if (value === undefined || value === null) return Ok("");
  return Err({ why: "non-primitive-param-value", data: value });
}
